import comp from "./MiddleContainer";
export default comp;
